import React from "react";
import Banner from "./Banner";

const BannerMobile = React.memo(({ isDisplayed }) => {
  return <Banner isDisplayed={isDisplayed} />;
});
export default BannerMobile;
